<template>
  <article class="QuestionFilters" :class="[ alert ? 'QuestionFilters_with' : '' ]">


    <div class="QuestionFilters_wrapper">
      <div class="QuestionFilters_header" v-if="!isMobile">
        <div class="QuestionFilters_header_count">{{ index + 1 }}</div>
        <div class="QuestionFilters_header_question"><small v-if="datas.tag">{{ datas.tag }}<br></small><span v-html="datas.label"></span></div>
      </div>

      <div class="QuestionFilters_header" v-if="isMobile">
        <div class="QuestionFilters_header_count">{{ index + 1 }}</div>
        <div class="QuestionFilters_header_question"><small v-if="datas.tag">{{ datas.tag }} :<br></small><span v-html="datas.label"></span></div>
      </div>

      <transition name="fade" mode="out-in">
        <div class="QuestionFilters_results" v-if="!noResults" key="results">
          <div class="Loader" v-if="onLoad"></div>

          <div class="QuestionFilters_results_lines">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="QuestionFilters_results_row" :data-color="answer.color" v-for="(answer, index) in datas.answers" :key="index" ref="answers" :class="{ 'QuestionFilters_results_row_user': userAnswer && userAnswer.participantAnswer && answer.id == userAnswer.participantAnswer.id }">
            <div class="QuestionFilters_results_row_calc">
              <div class="QuestionFilters_results_row_calc_percent" :style="{ width: isVisible ? calcWidth(answer.id) : '0%' }">
                <span><animated-number
                  :value="answer.results"
                  :easing="'easeOutQuad'"
                  :duration="600"
                  :delay="300"
                  :formatValue="format"
                /></span>
              </div>
            </div>
            <div class="QuestionFilters_results_row_answer">
              {{ answer.label }}
              <span v-if="userAnswer && userAnswer.participantAnswer && answer.id == userAnswer.participantAnswer.id">(Vous)</span>
            </div>
          </div>
        </div>

        <div class="QuestionFilters_results" v-else key="noresults">
          <p class="Oups">Mince !<br>Nous n'avons pas assez de données pour ce cas.</b>
          <p>Essayez en choisissant d'autres filtres.</p>
        </div>
      </transition>

      <!-- <div class="QuestionFilters_filters">
        <button class="QuestionFilters_filters_cta" @click="isOpen = !isOpen" v-if="isMobile" :class="{ 'QuestionFilters_filters_cta_open': isOpen }">Filter les résultats <i class="far fa-angle-down"></i></button>
        <div class="QuestionFilters_filters_choices" v-show="isOpen">
          <p>Filtrer les résultats (2 filtres maximum)</p>

          <div class="QuestionFilters_filters_choices_field" v-for="(row, index) in filters" :key="index" :class="{ 'QuestionFilters_filters_choices_field_buttons': row.type == 'buttons' }">
            <h5 v-if="row.name.length > 2">{{ row.name }}</h5>

            <div class="QuestionFilters_filters_choices_field_select" v-if="row.type == 'select'" :class="{ 'QuestionFilters_filters_choices_field_select_selected': selectActive }">
              <i class="QuestionFilters_filters_choices_field_select_arrow fas fa-sort-down"></i>
              <i class="QuestionFilters_filters_choices_field_select_picto fas fa-map-marker-alt"></i>
              <select class="Cta Cta_line Cta_select" :class="{ 'Cta_selected': selectActive }" @change="toggleFilter" data-index="9" v-if="$tools.isTouchDevice()" ref="select">
                <option selected value="remove" disabled>Choisir une région</option>
                <option v-for="(filter, index) in row.filters" :data-slug="filter.slug" data-index="9" :key="index" @click="toggleFilter">{{ filter.name }}</option>
              </select>

              <v-select class="Cta Cta_line Cta_select" :class="{ 'Cta_selected': selectActive }" ref="vselect" v-else :dir="'auto'" :clearable="false" :searchable="false" :options="row.filters" label="name" placeholder="Choisir une région" v-model="select" @input="toggleFilter">
                <template slot="option" slot-scope="option">
                  <li v-html="option.name" :data-slug="option.slug" data-index="9"></li>
                </template>
              </v-select>
            </div>

            <button v-else class="Cta Cta_line" v-for="(filter, i) in row.filters" :data-slug="filter.slug" :data-index="row.id" :key="i" @click="toggleFilter" :data-i="i"  :class="{ 'Cta_selected': filtersSlugs.some(e => e.slug === filter.slug) }">{{ filter.name }}</button>

          </div>

          <button class="QuestionFilters_filters_choices_reset" @click="reset" :style="{ visibility: filtersSlugs.length > 0 ? 'visible' : 'hidden'}">Réinitialiser <i class="far fa-redo"></i></button>

        </div>
      </div> -->
    </div>

    <NotePush :data="advice" v-if="advice" ref="note"/>

  </article>
</template>

<script>
  import scrollUpdate from '@/mixins/scrollUpdate'
  import filtersBlock from '@/mixins/filtersBlock'

  import AnimatedNumber from "animated-number-vue";
  import NotePush from '@/components/NotePush'

  export default {
    name:"QuestionFilters",
    props: [ 'filters', 'data', 'index', 'userAnswer', 'advice', 'noResults' ],
    mixins: [ scrollUpdate, filtersBlock ],
    components: { NotePush, AnimatedNumber },
    data() {
      return {
        values: []
      }
    },
    watch: {
      data()
      {
        this.format
      }
    },
    methods: {
      onUnVisible()
      {
        for (let i = 0; i < this.values.length; i++) {
          this.values[i] = 0
        }
      },
      onVisible()
      {
        for (let i = 0; i < this.values.length; i++) {
          this.values[i] = this.datas.answers[i].results
        }
      },
      format(value)
      {
        return Number(value).toFixed(0).replace(".", ",") + '%';
      }
    },
    mounted()
    {
      if(!this.$tools.isMobile())
      {
        this.$scroll.set(this.$el, { y: 0, opacity: 1 }, { y: 60, opacity: 0.5 }, { y: 0, opacity: 1 }, null, 1)
      }
    }
  }
</script>

<style lang="stylus">
.QuestionFilters

  position relative
  width 100%
  max-width 590px
  margin-top 60px

  @media screen and (max-width: 1260px)

    max-width unset

  @media $small
    margin-bottom 10px
    margin-top 0px

  .Loader

    position absolute
    top 0px
    right 0px
    width 13px
    height 13px
    border-width 2px

    @media $small

      bottom 0px
      top auto
      right 15px

  &_wrapper

    // display flex
    // flex-direction row
    // align-items stretch
    // justify-content space-around
    padding 60px 20px
    background: #FFFFFF;
    box-shadow: 0 2px 24px 0 rgba(0,0,0,0.10);
    border-radius: 5px;

    @media $small

      display block
      padding 30px 20px

  &_results

    width 100%
    margin 0px auto
    box-sizing border-box
    position relative
    max-width 390px
    display flex
    flex-direction column
    justify-content center

    .Oups

      color $red
      font-size 14px
      font-weight 600
      margin-bottom 8px

    &_lines

      display flex
      flex-direction row
      justify-content space-between
      width calc(35% + 65px)
      box-sizing border-box
      position absolute
      top 0px
      left 0px
      height 100%
      padding-left 20px

      span

        display block
        height 100%
        width 1px
        background-color $blue
        opacity 0.1

    &_row

      display flex
      align-items center
      flex-direction row
      width 100%
      margin-top 15px

      &:last-child

        margin-bottom 15px



      &_user

        // .QuestionFilters_results_row_calc_percent

        //   background-color $cyan!important

        //   span

        //     color $blue

        .QuestionFilters_results_row_answer

          span

            font-weight 500
            color $blue
            display block

      &[data-color='6']

        .QuestionFilters_results_row_calc_percent

          background-color #1F276D

      &[data-color='5']

        .QuestionFilters_results_row_calc_percent

          background-color #4F5799

      &[data-color='4']

        .QuestionFilters_results_row_calc_percent

          background-color #7A80B1

      &[data-color='7']

        .QuestionFilters_results_row_calc_percent

          background-color #B3B3B3

      &[data-color='3']

        .QuestionFilters_results_row_calc_percent

          background-color #D16E7A

      &[data-color='2']

        .QuestionFilters_results_row_calc_percent

          background-color #BF3748

      &[data-color='1']

        .QuestionFilters_results_row_calc_percent

          background-color #A20619

      &_answer

        text-align left
        font-family: $f-title
        font-weight normal
        font-size: 14px;
        color: $s1
        line-height: 15px;

      &_calc

        width 35%
        min-width 35%
        position relative
        height 35px
        margin-left 60px
        margin-right 10px

        &_percent

          width 30%
          height 100%
          background: $blue
          position absolute
          top 0px
          right 0px
          overflow hidden
          box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);
          border-radius: 10px 0 0 10px;
          transition width 0.8s 0.3s $ease

          span

            font-size: 14px;
            font-weight bold
            color: white
            text-align right
            position absolute
            top 50%
            right 5px
            transform translateY(-50%)
            letter-spacing: 0;



  &_filters

    max-width 390px
    margin auto auto
    width 100%

    @media $small

      max-width none

    &_cta

      font-size: 14px;
      color: $blue
      appearance none
      border 0px
      border-top 1px solid $s2
      letter-spacing: 0;
      text-transform none!important
      text-align: center;
      font-family $f-title
      font-weight normal
      height 45px
      width 100%
      background-color white
      cursor pointer

      &_open

        i

          transform rotate(180deg)

      i

        margin-left 5px
        transition 1s $ease

    &_choices

      padding 30px 20px
      box-sizing border-box
      width 100%

      @media $small

        border-top 1px solid $s2

      &_reset

        appearance none
        display block
        background-color transparent
        color $s1
        font-size 14px
        text-align left
        margin-top 10px
        padding 0px
        text-decoration underline
        margin-bottom 30px
        cursor pointer
        border 0px

        i

          margin-left 8px

      p

        font-family: $f-title
        font-weight 500
        font-size: 18px;
        color: $blue
        margin-bottom 20px
        letter-spacing: -0.3px;
        text-align: left;
        line-height: 22px;

      &_field

        display flex
        flex-direction row
        flex-wrap wrap
        align-items stretch
        justify-content flex-start
        margin-bottom 5px

        @media $medium

          max-width 360px

        &:last-child

          margin-bottom 0px

        .Cta

          text-transform none!important
          font-size 14px

        &_buttons

          button[data-i="0"]

            margin-right 0px
            border-radius 10px 0px 0px 10px

          button[data-i="1"]

            margin-left 0px
            border-radius 0px 10px 10px 0px
            border-left 0px

        &_select

          position relative
          width 100%
          max-width 285px

          select

            width 100%

          &_arrow

            position absolute
            top calc(50% - 2px)
            font-size 16px
            color $grey
            right 15px
            line-height 14px
            transform translateY(-50%)
            z-index 2
            transition color 0.4s $ease

          &_picto

            position absolute
            top 50%
            font-size 16px
            color $blue
            left 15px
            line-height 14px
            transform translateY(-50%)
            z-index 2
            transition color 0.4s $ease

          &_selected

            .QuestionFilters_filters_choices_field_select_arrow, .QuestionFilters_filters_choices_field_select_picto

              color white!important

        h5

          width 100%
          display block
          font-family: $f-title
          font-weight normal
          font-size: 14px;
          color: $s1
          margin-bottom 10px
          letter-spacing: 0;
          text-align: left;

        .vs__dropdown-menu

          max-height 100px

        .vs__selected-options, .vs__dropdown-toggle, .vs__selected-options input, .vs__selected-options input::placeholder, .vs__selected

          margin 0px
          padding 0px
          font-size: 14px;
          height 100%
          text-transform none
          color $blue
          border 0px
          background transparent

        .vs__dropdown-option

          font-size: 14px;
          text-transform none
          color $blue

        .vs__dropdown-option--highlight

          background-color $n2

        .vs__actions

          display none

        .Cta

          margin-right 10px
          margin-bottom 10px
          font-size: 14px;
          height 30px
          line-height 30px
          padding 0px 5px
          border-radius: 10px;
          text-transform none

          &_line

            border-color $s2
            min-width auto

            &:hover

              color $blue!important
              background-color white!important
              border-color $s2!important

          &_select

            margin-bottom 0px
            box-sizing border-box
            padding 0px 0px 0px 35px
            text-transform none

            &:hover

              background-color transparent!important

            &.Cta_selected

              color white!important

              .vs__selected-options, .vs__selected, .vs__search

                color white!important

          &_selected, &_selected:hover

            color white!important
            border-color $blue!important
            background-color $blue!important
            box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);
            opacity 1

          &:last-child

            margin-right 0px

  &_header

    width 100%
    max-width 400px
    box-sizing border-box
    margin auto
    margin-bottom 60px

    @media $small

      display flex
      margin 0px
      flex-direction row
      align-items stretch
      justify-content flex-start
      margin-bottom 0px

    &_question

      font-family: $f-title;
      font-weight 500
      font-size: 18px;
      line-height: 22px;
      color: $blue
      text-align center
      letter-spacing: -0.3px;
      margin-top 30px

      @media $small

        text-align left
        font-size: 14px;
        line-height: 17px;
        margin-top 0px
        margin-bottom 30px

    &_count

      font-family: $f-title;
      font-weight 500
      font-size: 14px;
      color: $red
      display table
      letter-spacing: -0.16px;
      line-height: 14px;
      position relative
      padding-bottom 3px
      margin auto

      @media $small

        margin 0px
        margin-right 25px
        top 8px

      &:before

        content ''
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -55%) rotate(-45deg)
        width 31px
        height 31px
        border 1px solid $red

        @media $small

          height 21px
          width 21px



</style>
